{
	"orderTerms": {
		"label": "Срок ордера",
		"day": "DAY",
		"gtc": "GTC",
		"opg": "OPG",
		"cls": "CLS",
		"ioc": "IOC",
		"dayPlus": "DAY+"
	}
}
